"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildString = void 0;
var constants_1 = require("../constants");
var helpers_1 = require("./utils/helpers");
var common_1 = require("../common");
var formatters_1 = require("./utils/formatters");
var alarms_1 = require("./utils/alarms");
var dates_1 = require("./utils/dates");
var buildString = function (event, prevResult) {
    var result = prevResult;
    var _loop_1 = function (key, value) {
        var valueAny = value;
        var delimiter = (0, helpers_1.getDelimiter)(valueAny);
        var isDateKey = (0, common_1.checkIfIsDateKeyToString)(key);
        if (isDateKey && key !== constants_1.EXDATE_KEY) {
            result += (0, dates_1.parseDateRows)(key, valueAny, delimiter);
        }
        else {
            switch (key) {
                case constants_1.EXDATE_KEY:
                    valueAny.forEach(function (item) {
                        result += (0, dates_1.parseDateRows)(key, item, delimiter);
                    });
                    break;
                case constants_1.ATTENDEE_KEY:
                    valueAny.forEach(function (item) {
                        result += (0, formatters_1.foldLine)('ATTENDEE;' + (0, formatters_1.mapObjToString)(item)) + '\n';
                    });
                    break;
                case constants_1.ORGANIZER_KEY:
                    result += (0, formatters_1.foldLine)('ORGANIZER;' + (0, formatters_1.mapObjToString)(valueAny)) + '\n';
                    break;
                case constants_1.ALARMS_KEY:
                    result += (0, alarms_1.formatAlarmsToString)(valueAny);
                    break;
                default:
                    result +=
                        typeof valueAny === 'string'
                            ? (0, formatters_1.foldLine)("".concat((0, formatters_1.transformToICalKey)(key)).concat(delimiter).concat((0, formatters_1.parseNewLine)(valueAny))) + '\n'
                            : "".concat((0, formatters_1.transformToICalKey)(key), ";").concat((0, formatters_1.mapGeneralObjToString)(valueAny)) + '\n';
            }
        }
    };
    // Build event string from object props
    for (var _i = 0, _a = Object.entries(event); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return result;
};
exports.buildString = buildString;
/**
 * Build iCal string
 * @param iCalObj
 */
var toString = function (iCalObj) {
    var calendar = iCalObj.calendar, events = iCalObj.events, todos = iCalObj.todos;
    // build calendar base string
    var result = (0, helpers_1.buildCalendarBaseString)(calendar);
    // add events
    result = (0, helpers_1.buildStringFromArrayItems)(result, events);
    // add todos
    result = (0, helpers_1.buildStringFromArrayItems)(result, todos);
    result += constants_1.CALENDAR_END;
    return result;
};
exports.default = toString;
